var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxsRulersvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.875 7H3.125C1.953 7 1 7.897 1 9V15C1 16.103 1.953 17 3.125 17H20.875C22.047 17 23 16.103 23 15V9C23 7.897 22.047 7 20.875 7ZM7 12H5V9H7V12ZM11 13H9V9H11V13ZM15 12H13V9H15V12ZM19 13H17V9H19V13Z",
    fill: "#20A8E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsRulersvg);
export default __webpack_public_path__ + "static/media/bxs-ruler.svg.f68b2d0aa3ba58119c848b57e0286b81.svg";
export { ForwardRef as ReactComponent };